import { gql } from 'graphql-tag';

import { TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { CurrencyType } from '@libs/types';
import { CardPaymentMerchantEnum } from '@libs/backend-common';

export type cardPayment = {
  amount: number;
  amountToSave?: number;
  asset: CurrencyType;
  cardId?: number;
  isCardless?: boolean;
  merchantName?: CardPaymentMerchantEnum;
  shouldSaveCard?: boolean;
};
export type CreateDirectCryptoTransactionProps = {
  baseAssetCode?: string;
  cardPaymentRecord?: cardPayment;
};

export type createDirectCryptoTransactionResponse = {
  redirectUrl: string;
};

export type CreateDirectCryptoTransactionResponse = {
  createDirectCryptoTransaction: DefaultApiResponse<createDirectCryptoTransactionResponse>;
};

export const createDirectCryptoTransactionMutation: TypedDocumentNode<
  CreateDirectCryptoTransactionResponse,
  DefaultArg<CreateDirectCryptoTransactionProps>
> = gql`
  mutation CreateDirectCryptoTransaction($record: DirectCryptoRecord!) {
    createDirectCryptoTransaction(record: $record) {
      redirectUrl
    }
  }
`;
